import {
  Box,
  Button,
  Icon,
  OverlayProvider,
  Typography,
} from "@bca/ui-library";
import css from "@styled-system/css";
import React from "react";

import Modal from "../common/components/Modal";
import { useViewport } from "../hooks/useViewport.hook";

const SaveSearchErrorModal = ({
  isOpen,
  onClose,
  setIsModalOpen,
  pushAnalyticsError,
}) => {
  const viewport = useViewport(0);

  function closeModal() {
    let close = onClose();
    let pushAnalytics = pushAnalyticsError("error-back");
    return close && pushAnalytics;
  }

  return (
    <>
      {isOpen && (
        <OverlayProvider>
          <Modal
            role="dialog"
            isOpen={isOpen}
            onClose={closeModal}
            fullScreen={viewport === "mobile"}
            isDismissable
            css={`
              display: flex;
              flex-direction: column;
              justify-content: space-between;
            `}
            aria-label="Save search error modal"
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              width={
                viewport === "mobile"
                  ? "100%"
                  : viewport === "tablet"
                  ? "400px"
                  : "650px"
              }
            >
              <Icon
                name="exclamation-triangle"
                color="grey-blue"
                width="62px"
                mt={viewport === "mobile" ? "140px" : "18px"}
              />
              <Typography variant="h4" m="0" mt="19px">
                Something went wrong...
              </Typography>
              <Typography
                variant="body"
                mb="36px"
                color="grey-blue"
                textAlign="center"
              >
                Unfortunately we were unable to save your search. Please try
                again or call customer services if the issue persists.
              </Typography>
            </Box>
            <Box display="flex" flexDirection="row" justifyContent="center">
              <Button
                css={`
                  bottom: 0;
                  ${css({
                    color: "primary-light-blue",
                    backgroundColor: "primary-white",
                  })};
                  border: 2px solid #2196f3;
                  box-sizing: border-box;
                  border-radius: 8px;
                  :hover {
                    color: white;
                  }
                `}
                mr="7px"
                width="180px"
                p="0"
                onClick={() => {
                  onClose();
                  pushAnalyticsError("error-back");
                }}
              >
                Back to results
              </Button>
              <Button
                css={`
                  bottom: 0;
                `}
                ml="7px"
                width="180px"
                p="0"
                onClick={() => {
                  onClose("error-save");
                  setIsModalOpen(true);
                  pushAnalyticsError("error-save");
                }}
              >
                Save Search
              </Button>
            </Box>
          </Modal>
        </OverlayProvider>
      )}
    </>
  );
};

export default SaveSearchErrorModal;
